import { useEffect, useState } from 'react';
import EphanCompetitionsService from 'services/EphanCompetitionsService';
import { isEphanEvent } from 'helpers/eventUtils';

/**
 * Reads the entry count of an imported competition straight from e-phan.
 *
 * The sync writes a snapshot of it into the event, but entries come in all day
 * and a stale number is visible to the user. Falls back to the synced value when
 * e-phan is unreachable, so the page never ends up worse off than before.
 */
export const useEphanLive = (event) => {
  const [live, setLive] = useState(null);

  // Keyed on primitives so switching between events refetches but a re-render
  // with a new object identity does not.
  const ephanId = event?.ephanId;
  const isImported = Boolean(event) && isEphanEvent(event);

  useEffect(() => {
    setLive(null);

    if (!ephanId || !isImported) return;

    let cancelled = false;

    EphanCompetitionsService.getLiveRegistration(ephanId).then(({ result }) => {
      if (!cancelled && result) {
        setLive(result);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [ephanId, isImported]);

  const entriesCount = live?.registration?.entriesCount ?? event?.entriesCount;

  return {
    entriesCount: Number.isFinite(entriesCount) ? entriesCount : null,
    maxEntries: live?.registration?.maxEntries ?? event?.maxEntries ?? null,
    isLive: Boolean(live),
  };
};
